var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0371d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de290f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14285714 5.47838509c-.60797988-.38095238-.76190476.31123914-.76190476 0 0-.63118257.68223276-1.14285714 1.52380952-1.14285714.8415768 0 1.5238095.51167457 1.5238095 1.14285714-.7229352 0-.7951534.38095238-1.1428571.38095238-.42659125 0-.53487727 0-1.14285716-.38095238zm.95238096-.14505176c.1051971 0 .1904762-.08527909.1904762-.19047619 0-.10519709-.0852791-.19047619-.1904762-.19047619-.10519711 0-.1904762.0852791-.1904762.19047619 0 .1051971.08527909.19047619.1904762.19047619zm-1.37976861 1.49520512c.17443116-.69594402-.53144747-.62843631-.23544145-.7246145.60029028-.19504614 1.29774324.29567964 1.55780476 1.0960667.2600615.8003871-.0157485 1.60734512-.61603874 1.80239129-.22339924-.6875523-.60802316-.63851512-.71546949-.96920099-.13182392-.40571238-.16528617-.50869849.00914492-1.2046425zm.43225432.86094467c.03250773.10004838.13996564.15480092.24001402.12229318.10004838-.03250765.15480091-.13996556.12229326-.24001396-.03250766-.10004839-.13996564-.15480094-.24001402-.12229324-.10004838.03250768-.15480092.13996561-.12229326.24001402zm-1.84839647-.85019412c.71578428-.04916468.43345209-.69963414.61639388-.44783639.37099985.51063743.11981668 1.32559722-.5610332 1.82026358-.68084991.49466644-1.53354257.48171939-1.90454238-.02891802.58486692-.42493074.41937444-.77557643.70067266-.97995155.34511956-.25074404.43272477-.31439295 1.14850904-.36355762zm-.68523309.67714481c-.08510624.0618333-.10397268.18095133-.04213938.26605754.0618333.08510629.18095133.10397273.26605757.04213943.08510623-.06183329.10397268-.18095139.04213938-.26605759-.06183331-.08510624-.18095133-.10397268-.26605757-.04213938zm.23739671-2.02065396c.26794789.66555857.79933571.19603863.6163939.44783638-.37099981.51063742-1.22369247.52358449-1.90454238.02891809-.6808499-.49466641-.93203303-1.3096262-.56103322-1.82026362.58486692.42493069.86721082.1591825 1.14850904.36355762.34511956.25074404.43272477.31439295.70067266.97995153zm-.85575166-.44244614c-.08510624-.06183331-.20422427-.04296687-.26605757.04213937s-.04296686.20422428.04213937.26605757c.08510624.0618333.20422428.04296687.26605758-.04213937s.04296686-.20422428-.04213938-.26605757zm1.99511571-.39863873c-.55018335.46050249.06056449.82079267-.23544152.72461448-.60029027-.19504614-.87610019-1.00200419-.61603867-1.80239125s.95751448-1.29111284 1.55780476-1.0960667c-.22339924.6875523.11659132.87395661.00914499 1.20464249-.13182392.40571238-.16528617.50869848-.71546956.96920098zm.15634949-.95059157c.03250773-.10004839-.0222448-.20750631-.12229326-.240014-.10004838-.0325077-.20750629.02224485-.24001394.12229324-.03250774.10004838.0222448.20750631.12229325.24001401.10004838.03250768.20750629-.02224487.24001395-.12229325z",
    fill: "url(#a)",
    mask: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/HK.a46ebf3fbe3fbc19f99ae9c60167e725.svg";
export { ForwardRef as ReactComponent };